<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/cloudPrint.png" /></div>
      <p>云打印SDK</p>

    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/cloudPrintSDK/'
export default {
  name: 'index',
  data() {
    return {
      fileList: [{
        label: '1.0.0',
        linkList: [
          ur + '1.0.0/cloudPrintSDK.js'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListCloudPrint.vue